import { Outlet } from "react-router-dom"
import useRedirect from "./useRedirect"

const PublicOutlet = () => {
    useRedirect()
    return <Outlet />
}

export default PublicOutlet
